import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Contact() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Animation happens only once
    });
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <section id="contact" class="contact section">
        {/* Section Title */}
        <div class="container section-title" data-aos="fade-up">
          <h2>Contact</h2>
          <p>Get in touch with us!</p>
        </div>
        {/* End Section Title */}

        <div
          class="container"
          // data-aos="fade-up" data-aos-delay="100"
        >
          <div class="row gy-4">
            <div class="col-lg-6">
              <div
                class="info-item d-flex flex-column justify-content-center align-items-center"
                // data-aos="fade-up"
                //   data-aos-delay="200"
              >
                <i class="bi bi-geo-alt"></i>
                <h3>Address</h3>
                 <p>2nd floor, Maitreya Business Park,</p>
                <p>Hanuman road, above Mad Over Doughnuts,</p>
                <p>opp. Parleshwar Mandir, Vile Parle (East),</p>                
                <p>Mumbai - 400057, India</p>
              </div>
            </div>
            {/* End Info Item */}

            {/* <div class="col-lg-3 col-md-6">
      <div class="info-item d-flex flex-column justify-content-center align-items-center" 
      // data-aos="fade-up"
      //   data-aos-delay="300"
        >
        <i class="bi bi-telephone"></i>
        <h3>Call Us</h3>
        <p>+91 9833 326 434</p>
      </div>
    </div> */}

            <div class="col-lg-3 col-md-6">
              <div
                class="info-item d-flex flex-column justify-content-center align-items-center"
                // data-aos="fade-up"
                //   data-aos-delay="400"
              >
                <i class="bi bi-envelope"></i>
                <h3>Email Us</h3>
                <p>info@symholding.com</p>
              </div>
            </div>
            {/* End Info Item */}
          </div>

          <div class="row gy-4 mt-1">
            <div
              class="col-lg-6"
              // data-aos="fade-up" data-aos-delay="300"
            >
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d502.14143994261497!2d72.84692957018437!3d19.1031924008716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c90d9b6c690b%3A0xa91a1179aabc3c!2sMaitreya%20business%20park!5e0!3m2!1sen!2sin!4v1765809339421!5m2!1sen!2sin" 
              frameBorder="0"
              style={{border:"0", width:"100%", height:"400px"}} 
              allowfullscreen="" 
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            {/* End Google Maps */}

            <div className="col-lg-6">
              <form
                // action="forms/contact.php"
                // method="post"
                className="php-email-form"
                // data-aos="fade-up"
                //   data-aos-delay="400"
              >
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      required=""
                    />
                  </div>

                  <div className="col-md-6 ">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Your Email"
                      required=""
                    />
                  </div>

                  <div class="col-md-12">
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      placeholder="Subject"
                      required=""
                    />
                  </div>

                  <div class="col-md-12">
                    <textarea
                      className="form-control"
                      name="message"
                      rows="6"
                      placeholder="Message"
                      required=""
                    ></textarea>
                  </div>

                  <div className="col-md-12 text-center">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">
                      Your message has been sent. Thank you!
                    </div>

                    <button type="submit">Send Message</button>
                  </div>
                </div>
              </form>
            </div>
            {/* End Contact Form */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
